/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 11:19
 */
import Column from './Column';
import flatpickr from 'flatpickr/dist/flatpickr';

class EpochColumn extends Column {

  constructor(params) {
    super(params);
    const {
      format,
      selector,
      enableTime = false,
      time24hr = true,
      minuteIncrement = 1,
      enableSeconds = true,
      noCalendar = false,
    } = params;
    this.format = format;
    this.selector = selector;
    this.enableTime = enableTime;
    this.time24hr = time24hr;
    this.minuteIncrement = minuteIncrement;
    this.enableSeconds = enableSeconds;
    this.noCalendar = noCalendar;
    this.init();
  }

  init() {
    const options = {
      allowInput: true,
      dateFormat: this.format,
      enableSeconds: this.enableSeconds,
      enableTime: this.enableTime,
      minuteIncrement: this.minuteIncrement,
      noCalendar: this.noCalendar,
      time_24hr: this.time24hr,
    };
    const elements = document.querySelectorAll(`.input-group${this.selector}`);

    elements.forEach(element => {
      const input = element.querySelector('input');
      const instanceOptions = {
        defaultDate: input.value,
        ...options
      }
      flatpickr(input, instanceOptions);
    });
  }

}

export default EpochColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/EpochColumn.js